import { ReactNode, useEffect, useMemo } from 'react';

import { useSelector } from 'react-redux';

import { SocketContext } from '@/contexts/rtm';
import { useRtmSetup } from '@/hooks/rtm/useRtmSetup';
import { selectAccountId } from '@/redux/session/selectors';
import { SocketEvent } from '@/shared/types/rtm';

type RtmProviderProps = { children: ReactNode };

const RtmProvider = ({ children }: RtmProviderProps) => {
  const { socket, isConnected } = useRtmSetup();
  const account_id = useSelector(selectAccountId);

  useEffect(() => {
    if (account_id && isConnected) {
      socket.emit(SocketEvent.subscribe_account, { account_id });
    }
    return () => {
      if (account_id && isConnected) {
        socket.emit(SocketEvent.unsubscribe_account, { account_id });
      }
    };
  }, [account_id, isConnected, socket]);

  // A context change bypasses `memo`, so a fresh object re-renders every socket consumer.
  const value = useMemo(() => ({ socket, isConnected }), [socket, isConnected]);

  return <SocketContext.Provider value={value}>{children}</SocketContext.Provider>;
};

export default RtmProvider;
